import { useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './header/Header';
import Sidebar from './sidebar/Sidebar';

const Main = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const closeMobileMenu = useCallback(() => setIsMobileMenuOpen(false), []);

  return (
    <div className='flex h-screen flex-col bg-background md:h-[100dvh]'>
      <Header onMenuClick={() => setIsMobileMenuOpen(true)} />
      <div className='flex min-h-0 flex-1 flex-col overflow-hidden md:flex-row'>
        <Sidebar
          isMobileMenuOpen={isMobileMenuOpen}
          onMobileMenuClose={closeMobileMenu}
        />
        <main className='min-w-0 flex-1 overflow-y-auto p-4 sm:p-6'>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Main;
